import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ContracteProgramariService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;
    private findContractUrl = this.basePath + environment.interop.dgaspc.activitati.contracteProgramari.findContract;
    private postMessageUrl = this.basePath + environment.interop.dgaspc.activitati.contracteProgramari.postMessage;
    private exportHistoryUrl = this.basePath + environment.interop.dgaspc.activitati.contracteProgramari.exportHistory;
    private updatePrezentaUrl = this.basePath + environment.interop.dgaspc.activitati.contracteProgramari.updatePrezenta;
    public printContractUrl = this.basePath + environment.interop.dgaspc.activitati.contracteProgramari.printContract;
    private exportCSVUrl = this.basePath + environment.interop.dgaspc.activitati.contracteProgramari.exportCSV;
    private reziliereContractUrl = this.basePath + environment.interop.dgaspc.activitati.contracteProgramari.reziliereContract;

    constructor(private http: HttpClient) { }

    getContract(id: number) {
        return this.http.get(this.findContractUrl + id);
    }

    postMessage(id: number, message: any) {
        return this.http.post(this.postMessageUrl + id, message, this.httpOptions);
    }

    exportHistory(entity_id: number, user_type: number): Observable<Blob> {
        return this.http.get(this.exportHistoryUrl + entity_id + '/' + user_type, {
            responseType: 'blob',
        });
    }

    updatePrezenta(id_programare: number, status: string, status_obs: string = ''): Observable<any> {
        return this.http.patch(this.updatePrezentaUrl + id_programare + '/status', { status, status_obs });
    }

    exportCSV(params: any): Observable<Blob> {
        return this.http.post(this.exportCSVUrl, params, {
            responseType: 'blob',
        });
    }

    reziliereContract(id_contract: number): Observable<any> {
        return this.http.patch(this.reziliereContractUrl + id_contract + '/status', { status: 'reziliat' });
    }
}
